// Error components must be Client Components
'use client';

import '../tailwind-woonstad.css';

import { GlobalError, SITES } from '@woonstad/ui-public-sites';

export default function GlobalErrorPage(props: Parameters<typeof GlobalError>[0]) {
  return (
    <GlobalError
      {...props}
      site={SITES.Woonstad}
    />
  );
}
